import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
const OPEN = '[u]';
const CLOSE = '[/u]';

/**
 * Wrap the current selection in [u]...[/u] using the Tiptap editor's own
 * commands. We deliberately insert BBCode as plain text (rather than adding a
 * real ProseMirror mark) because fof/rich-text stores content as markup and
 * flarum/bbcode already renders [u] — so this round-trips cleanly with zero
 * changes to fof/rich-text's serializer or schema.
 *
 * Everything is wrapped defensively: if any command is missing on this version
 * of Tiptap, we no-op rather than risk disrupting the composer.
 */
function wrapUnderline(editor) {
  if (!editor || typeof editor.chain !== 'function') return;
  try {
    const sel = editor.state.selection;
    const from = sel.from;
    const to = sel.to;
    if (sel.empty) {
      editor.chain().focus().insertContent(OPEN + CLOSE).setTextSelection(from + OPEN.length) // place cursor between the tags
      .run();
    } else {
      // Insert the closing tag first (higher position), then the opening tag,
      // so the earlier position isn't shifted by the later insertion.
      editor.chain().focus().insertContentAt(to, CLOSE).insertContentAt(from, OPEN).setTextSelection({
        from: from + OPEN.length,
        to: to + OPEN.length
      }).run();
    }
  } catch (e) {
    // fail safe — never break the editor
  }
}

/**
 * Attach a Ctrl/Cmd+U shortcut to the editor's DOM once. StarterKit's underline
 * is disabled in fof/rich-text, so Mod-U is free; we bind it ourselves without
 * needing a Tiptap extension (and therefore without bundling @tiptap/core).
 */
function attachShortcut(editor) {
  try {
    if (!editor || editor.__peakUnderlineBound) return;
    const dom = editor.view && editor.view.dom;
    if (!dom) return;
    editor.__peakUnderlineBound = true;
    dom.addEventListener('keydown', e => {
      if ((e.metaKey || e.ctrlKey) && !e.altKey && (e.key === 'u' || e.key === 'U')) {
        e.preventDefault();
        wrapUnderline(editor);
      }
    });
  } catch (e) {
    // fail safe
  }
}
app.initializers.add('peakstates-underline', () => {
  // TiptapMenu is lazy-loaded by fof/rich-text (only when the composer opens).
  // Passing the `ext:` import path makes Flarum's extend() defer our hook until
  // the module is actually loaded, then apply it to TiptapMenu.prototype.
  extend(
  // @ts-ignore — string import path form is resolved by flarum's extend at runtime
  'ext:fof/rich-text/common/components/TiptapMenu', 'items', function (items) {
    const editor = this && this.attrs && this.attrs.editor;
    if (!editor || !items) return;
    if (typeof items.has === 'function' && items.has('underline')) return;
    attachShortcut(editor);
    items.add('underline', Button.component({
      className: 'Button Button--icon Button--link',
      icon: 'fas fa-underline',
      title: app.translator.trans('peakstates-underline.forum.underline_tooltip'),
      onclick: () => wrapUnderline(editor)
    }),
    // Bold=90, Italic=80, Strike=75 — 74 tucks Underline right after Strike.
    74);
  });
});